import { atom } from "jotai";
import { featurePermissionMapper } from 'permissions';
import { TierInformation } from '../interfaces/clientConfiguration';

export const tierAtom = atom<TierInformation | null>(null);
